<div ngModalContent class="conclusion-remote-modal">
  <h2 nxHeadline="subsection-medium" class="u-text-center nx-margin-bottom-2m">
    {{ 'modals.conclusion-remote.title' | translate }}
  </h2>

  <p nxCopytext="normal" class="nx-margin-bottom-m">
    {{ 'modals.conclusion-remote'+ (isTravelAgency ? '.description-travel-agency' : '.description') | translate :
    (descriptionParams$ | async) }}
  </p>

  <nx-checkbox class="nx-margin-bottom-xl" [(ngModel)]="agreementChecked">
    {{ 'modals.conclusion-remote.agreement' | translate }}
  </nx-checkbox>

  <div class="conclusion-remote-modal--controls">
    <button nxButton (click)="handleClick()" [disabled]="!agreementChecked">
      {{ 'modals.conclusion-remote.button' | translate }}
    </button>
  </div>
</div>